import React, { Fragment, useContext } from "react";
import { Link } from "react-router-dom";

import { useSidebar } from "../../Hooks/useSidebar";
import { useAuth } from "../../Hooks/useAuthentication";
import { AuthContext, ProfileContext } from "../../Context";

const Header = () => {
  const { profile } = useContext(ProfileContext);

  const { token, setToken } = useContext(AuthContext);
  const { handleLogout } = useAuth(setToken);
  const { menuItems } = useSidebar();

  // ================================================================================

  return (
    <header className="navbar-light w-100 navbar-sticky header-static border-bottom navbar-dashboard">
      <nav className="navbar navbar-expand-xl">
        <div className="container">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
            aria-controls="navbarCollapse"
            aria-expanded="false"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <Link className="navbar-brand ms-3 me-auto" to={{ pathname: "/" }}>
            <img
              className="navbar-brand-item light-mode-item"
              src="/imgs/headerLogo.png"
              alt="logo"
            />
          </Link>

          <div className="collapse navbar-collapse" id="navbarCollapse">
            <ul className="navbar-nav navbar-nav-scroll mx-auto">
              {menuItems.map((item) => (
                <li className="nav-item" key={item.id}>
                  <Link to={{ pathname: item.path }}>
                    <div
                      data-bs-toggle="collapse"
                      data-bs-target="#navbarCollapse"
                      aria-controls="navbarCollapse"
                      aria-expanded="false"
                      className="nav-link d-block d-lg-none"
                    >
                      <i className={`bi bi-${item.icon} me-1`}></i>
                      {item.title}
                    </div>
                    <div className="nav-link d-none d-lg-block">
                      <i className={`bi bi-${item.icon} me-1`}></i>
                      {item.title}
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="nav flex-nowrap align-items-center">
            {token ? (
              <div className="nav-item ms-2 ms-md-3 dropdown">
                <Link
                  className="btn btn-primary-soft btn-round mb-0 d-flex justify-content-center align-items-center"
                  to={{ pathname: "/cart" }}
                >
                  <i className="bi-cart d-flex"></i>
                </Link>
              </div>
            ) : null}

            <div className="nav-item ms-2 dropdown">
              {token ? (
                profile.profile ? (
                  <div
                    className="avatar avatar-sm p-0"
                    id="profileDropdown"
                    role="button"
                    data-bs-auto-close="outside"
                    data-bs-display="static"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img
                      className="avatar-img rounded-circle"
                      src={profile.profile}
                      alt="avatar"
                    />
                  </div>
                ) : (
                  <div
                    id="profileDropdown"
                    role="button"
                    data-bs-auto-close="outside"
                    data-bs-display="static"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    className="btn btn-primary-soft btn-round mb-0 d-flex justify-content-center align-items-center"

                  >
                    <i className="bi-person fs-5 d-flex"></i>
                    </div>
                )
              ) : (
                <Link
                  className="btn btn-primary-soft btn-round mb-0 d-flex justify-content-center align-items-center"
                  to={{ pathname: "/login" }}
                >
                  <i className="bi-person fs-5 d-flex"></i>
                </Link>
              )}

              <ul
                className="dropdown-menu dropdown-animation dropdown-menu-end mw-100 shadow pt-3"
                aria-labelledby="profileDropdown"
              >
                <li className="px-3">
                  <div className="d-flex align-items-center">
                    <div className="avatar me-3">
                      {profile.profile ? (
                        <img
                          className="avatar-img rounded-circle"
                          src={profile.profile}
                          alt="avatar"
                        />
                      ) : (
                        <Link
                          className="btn btn-primary-soft btn-round mb-0 d-flex justify-content-center align-items-center"
                          to={{ pathname: "/profile" }}
                        >
                          <i className="bi-person fs-5 d-flex"></i>
                        </Link>
                      )}
                    </div>
                    <div className="flex-grow-1">
                      <Link
                        className="h6 mb-0 d-block mt-2 mt-sm-0 truncate"
                        to={{ pathname: "/profile" }}
                      >
                        {profile.first_name} {profile.last_name}
                      </Link>
                      <p className="small m-0">{profile.phoneNumber}</p>
                    </div>
                  </div>
                  <hr />
                </li>

                <li>
                  <Link className="dropdown-item" to={{ pathname: "/profile" }}>
                    <i className="bi bi-person fa-fw me-2"></i>ویرایش
                  </Link>
                </li>
                <li>
                  <div onClick={handleLogout} className="dropdown-item">
                    <i className="bi bi-power fa-fw me-2"></i>خروج
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
